import React from "react";

import { IssueParent } from "@common/models/issueTracking";
import { TicketKeyPill } from "@main/pages/shared/components/TicketKey/TicketKey";
import * as Icon from "@main/pages/shared/icons/icons";
import { DetailsTitle } from "@main/pages/shared/styles/DetailsWrapper.styles";

import * as Styled from "./ParentBreadcrumb.styles";

interface Props {
  parent: IssueParent;
}

/**
 * The parent half of the navbar breadcrumb on a ticket marked as a duplicate: the parent's title
 * and key, a separator, and the duplicate icon that qualifies the open ticket's title to its right.
 *
 * The title is plain text in the same `DetailsTitle` the open ticket's own title uses, so the two
 * read as one breadcrumb. The link to the parent lives in the `DuplicateOf` banner above the
 * details bar, not here.
 *
 * NO hooks and NO react-router components here, deliberately. `useCustomElementInjection` renders
 * the navbar element with its own `ReactDOM.render` into a detached node, so this subtree is a
 * SEPARATE React root with none of the app's providers: a `<Link>` throws on the null router
 * context ("Cannot destructure property 'basename'"), which takes the whole breadcrumb down with
 * it.
 *
 * `TicketKeyPill`, not `TicketKeyCopy` — the copy action copies the current location, which is the
 * open ticket rather than this one.
 */
export const ParentBreadcrumb = ({ parent }: Props) => (
  <Styled.Crumb>
    <DetailsTitle>
      <p>{parent.pretty_title}</p>
    </DetailsTitle>
    <TicketKeyPill ticketKey={parent.key.toString()} />
    <Styled.Separator>/</Styled.Separator>
    <Icon.DuplicateIcon />
  </Styled.Crumb>
);
